import { mockAwareFetch } from "@/portals/clinician/api/transport";
import type { AppNotification } from "@/stores/notificationsStore";

// Same shapes as the patient/clinician notification endpoints; only the calling admin's rows.

interface NotificationListResponse {
  data: AppNotification[];
  unreadCount: number;
}

export async function listAdminNotificationsApi() {
  const { data, error } = await mockAwareFetch<NotificationListResponse>("/api/v1/admin/notifications", { method: "GET", portal: "admin" });
  return { data, error: error?.message ?? null };
}

/** GET /api/v1/admin/notifications/unread-count — the bell counts from the list, so nothing calls this yet. */
export async function getAdminUnreadCountApi() {
  const { data, error } = await mockAwareFetch<{ unreadCount: number }>("/api/v1/admin/notifications/unread-count", { method: "GET", portal: "admin" });
  return { data, error: error?.message ?? null };
}

export async function markAdminNotificationReadApi(id: string) {
  const { data, error } = await mockAwareFetch<{ message?: string }>(`/api/v1/admin/notifications/${id}/read`, { method: "POST", portal: "admin" });
  return { data, error: error?.message ?? null };
}

export async function markAllAdminNotificationsReadApi() {
  const { data, error } = await mockAwareFetch<{ message?: string }>("/api/v1/admin/notifications/read-all", { method: "POST", portal: "admin" });
  return { data, error: error?.message ?? null };
}
